const defaultAudioContext = new AudioContext();

export default defaultAudioContext;
